//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import { ERC20DecString, ERC20Wei, toMweiErc20Wei } from '@shared/conversions'

export const textFieldValueToERC20DecString = (event: React.ChangeEvent<HTMLInputElement>): ERC20DecString => {
  return event.target.value as ERC20DecString
}

export const textFieldValueToErc20Wei = (event: React.ChangeEvent<HTMLInputElement>): ERC20Wei => {
  return toMweiErc20Wei(event.target.value as ERC20DecString)
}

export const textFieldValueToBigNumberWei = (event: React.ChangeEvent<HTMLInputElement>): bigint => {
  return BigInt(textFieldValueToErc20Wei(event))
}
